import ActivityIcon from './icons/activity-icon'
import AdminIcon from './icons/admin-icon'
import AiqIcon from './icons/aiq-icon'
import ArchiveIcon from './icons/archive-icon'
import ArrowLeftIcon from './icons/arrow-left-icon'
import ArrowRightIcon from './icons/arrow-right-icon'
import AtomIcon from './icons/atom-icon'
import AudienceIcon from './icons/audience-icon'
import BlankIcon from './icons/blank-icon'
import CalendarIcon from './icons/calendar-icon'
import CaretDownIcon from './icons/caret-down-icon'
import CaretLeftIcon from './icons/caret-left-icon'
import CaretRightIcon from './icons/caret-right-icon'
import CaretUpIcon from './icons/caret-up-icon'
import ChannelIcon from './icons/channel-icon'
import CheckIcon from './icons/check-icon'
import CircleIcon from './icons/circle-icon'
import CloseIcon from './icons/close-icon'
import ConfigureIcon from './icons/configure-icon'
import ContentIcon from './icons/content-icon'
import CorporateIcon from './icons/corporate-icon'
import DealershipIcon from './icons/dealership-icon'
import DecreaseIcon from './icons/decrease-icon'
import DefineIcon from './icons/define-icon'
import DriveIcon from './icons/drive-icon'
import EditIcon from './icons/edit-icon'
import EmailIcon from './icons/email-icon'
import ErrorIcon from './icons/error-icon'
import FacebookIcon from './icons/facebook-icon'
import FilterIcon from './icons/filter-icon'
import GlobeIcon from './icons/globe-icon'
import GripIcon from './icons/grip-icon'
import HelpIcon from './icons/help-icon'
import HistoryIcon from './icons/history-icon'
import IncompleteIcon from './icons/incomplete-icon'
import IncreaseIcon from './icons/increase-icon'
import LockIcon from './icons/lock-icon'
import MediumDigitalIcon from './icons/medium-digital-icon'
import MenuIcon from './icons/menu-icon'
import MessageaudienceIcon from './icons/messageaudience-icon'
import MessagingIcon from './icons/messaging-icon'
import MinusIcon from './icons/minus-icon'
import MoreIcon from './icons/more-icon'
import MultiChannelIcon from './icons/multi-channel-icon'
import NotificationsIcon from './icons/notifications-icon'
import PinIcon from './icons/pin-icon'
import PlusIcon from './icons/plus-icon'
import PreviewIcon from './icons/preview-icon'
import ReplaceIcon from './icons/replace-icon'
import ReportsIcon from './icons/reports-icon'
import ScheduleIcon from './icons/schedule-icon'
import SearchIcon from './icons/search-icon'
import SnailMailIcon from './icons/snail-mail-icon'
import StampIcon from './icons/stamp-icon'
import SuccessIcon from './icons/success-icon'
import SwitcherIcon from './icons/switcher-icon'
import TableSortIcon from './icons/table-sort-icon'
import TagIcon from './icons/tag-icon'
import TemplateIcon from './icons/template-icon'
import TrashIcon from './icons/trash-icon'
import UploadIcon from './icons/upload-icon'
import UserIcon from './icons/user-icon'
import WarningIcon from './icons/warning-icon'
import XIcon from './icons/x-icon'

export {
    ActivityIcon,
    AdminIcon,
    AiqIcon,
    ArchiveIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    AtomIcon,
    AudienceIcon,
    BlankIcon,
    CalendarIcon,
    CaretDownIcon,
    CaretLeftIcon,
    CaretRightIcon,
    CaretUpIcon,
    ChannelIcon,
    CheckIcon,
    CircleIcon,
    CloseIcon,
    ConfigureIcon,
    ContentIcon,
    CorporateIcon,
    DealershipIcon,
    DecreaseIcon,
    DefineIcon,
    DriveIcon,
    EditIcon,
    EmailIcon,
    ErrorIcon,
    FacebookIcon,
    FilterIcon,
    GlobeIcon,
    GripIcon,
    HelpIcon,
    HistoryIcon,
    IncompleteIcon,
    IncreaseIcon,
    LockIcon,
    MediumDigitalIcon,
    MenuIcon,
    MessageaudienceIcon,
    MessagingIcon,
    MinusIcon,
    MoreIcon,
    MultiChannelIcon,
    NotificationsIcon,
    PinIcon,
    PlusIcon,
    PreviewIcon,
    ReplaceIcon,
    ReportsIcon,
    ScheduleIcon,
    SearchIcon,
    SnailMailIcon,
    StampIcon,
    SuccessIcon,
    SwitcherIcon,
    TableSortIcon,
    TagIcon,
    TemplateIcon,
    TrashIcon,
    UploadIcon,
    UserIcon,
    WarningIcon,
    XIcon
}



// WEBPACK FOOTER //
// src/components/svg-icon/index.js